import { get, post } from '@/lib/api';
import preserveFailedAppFixerEnvelope from './preserveFailedAppFixerEnvelope.js';
import readAppFixerResult from './readAppFixerResult.js';

const requestAppFixer = ({ path, data, query, callback }) => {
  const method = data === undefined ? get : post;
  const encodedQuery = query && Object.fromEntries(Object.entries(query).map(([key, value]) => [key, value == null ? value : encodeURIComponent(String(value))]));
  return method(`v1/app-fixer/${path}`, {
    action: 'APP_FIXER_REQUEST',
    data,
    query: encodedQuery,
    onResponse: preserveFailedAppFixerEnvelope,
    callback: callback
      ? (result, failure) => {
          const read = readAppFixerResult({ result, failure });
          callback(read.data, read.error);
        }
      : undefined
  });
};

export default requestAppFixer;
